import { render } from "./chujihushi-news.vue?vue&type=template&id=1debf948&scoped=true"
import script from "./chujihushi-news.vue?vue&type=script&lang=js"
export * from "./chujihushi-news.vue?vue&type=script&lang=js"

import "./chujihushi-news.vue?vue&type=style&index=0&id=1debf948&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1debf948"]])

export default __exports__